// extracted by mini-css-extract-plugin
export default {"root":"mimic___style_root__8taFT","line":"mimic___style_line__K+n-h","feedItemBase":"mimic___style_feedItemBase__XGWzy","none":"mimic___style_none__2axDJ"};